<template>
  <div>
    <v-alert
      class="elevation-2 rounded-lg"
      prominent
      v-for="(condition, i) in multiselect"
      :key="i"
    >
      <v-container>
        <!-- <v-row v-if="LastQuestion.type === 'quickReply'" class="mb-3">
          <v-col cols="12">
            <v-chip class="white--text" color="#0278ae" @click="AddAllButton(i)"
              >เพิ่มเงื่อนไขจากปุ่มตัวเลือกทั้งหมด</v-chip
            >
          </v-col>
        </v-row> -->
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center">
              <v-row v-for="(choice, c) in qrbtn" :key="`${c}_qr`" no-gutters>
                <v-col cols="1" class="mr-n8">{{ c + 1 }}. </v-col>
                <v-col cols="11" class="d-flex">
                  <v-textarea
                    rows="3"
                    v-model="choice.text"
                    label="ตัวเลือก"
                    dense
                    outlined
                    disabled
                    :error="choice.errorLabel"
                    :error-messages="choice.errorLabelMsg"
                    @input="CheckMultiSelectType(i, c)"
                    :rules="[$store.getters.TextRule(choice.text)]"
                  >
                  </v-textarea>
                  <v-text-field
                    v-model="choice.value"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mx-3"
                    style="width: 1px"
                    :rules="[$store.getters.ScoreRule(choice.value)]"
                  >
                    <template #prepend> คะแนน </template>
                  </v-text-field>
                  <v-checkbox
                    v-model="choice.description"
                    class="mt-0"
                    label="มีรายละเอียด"
                  ></v-checkbox>
                  <v-btn
                    class="mx-2"
                    :style="{
                      visibility: 'hidden',
                    }"
                    icon
                  >
                  </v-btn>
                  <v-btn
                    color="#DE4F3B"
                    icon
                    :style="{
                      visibility: 'hidden',
                    }"
                    ><v-icon>mdi-trash-can-outline </v-icon></v-btn
                  >
                </v-col></v-row
              >
              <v-row
                v-for="(choice, c) in condition.selected"
                :key="c"
                no-gutters
              >
                <v-col cols="1" class="mr-n8"
                  >{{ qrbtn.length + (c + 1) }}.
                </v-col>
                <v-col cols="11" class="d-flex">
                  <v-textarea
                    rows="3"
                    v-model="choice.text"
                    label="ตัวเลือก"
                    dense
                    outlined
                    :error="choice.errorLabel"
                    :error-messages="choice.errorLabelMsg"
                    @input="CheckMultiSelectType(i, c)"
                    :rules="[$store.getters.TextRule(choice.text)]"
                  >
                  </v-textarea>
                  <v-text-field
                    v-model="choice.value"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mx-3"
                    style="width: 1px"
                    :rules="[$store.getters.ScoreRule(choice.value)]"
                  >
                    <template #prepend> คะแนน </template>
                  </v-text-field>
                  <v-checkbox
                    v-model="choice.description"
                    class="mt-0"
                    label="มีรายละเอียด"
                  ></v-checkbox>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            class="mx-2"
                            :style="{
                              visibility:
                                Object.keys(condition.selected).length > 1
                                  ? 'visible'
                                  : 'hidden',
                            }"
                            icon
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                            :disabled="!choice.text"
                          >
                            <v-avatar size="22" rounded>
                              <img
                                src="data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTMxLjYsNy45aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlYxMC4xICAgQzMzLjgsOC45LDMyLjgsNy45LDMxLjYsNy45eiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik0zMS42LDM3LjNoLTE5Yy0xLjIsMC0yLjIsMS0yLjIsMi4ydjE4LjVjMCwxLjIsMSwyLjIsMi4yLDIuMmgxOWMxLjIsMCwyLjItMSwyLjItMi4yVjM5LjQgICBDMzMuOCwzOC4yLDMyLjgsMzcuMywzMS42LDM3LjN6IE0yNy4yLDUzLjZIMTYuOXYtOS44aDEwLjNWNTMuNnoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMzEuNiw2Ny43aC0xOWMtMS4yLDAtMi4yLDEtMi4yLDIuMnYxOC41YzAsMS4yLDEsMi4yLDIuMiwyLjJoMTljMS4yLDAsMi4yLTEsMi4yLTIuMlY2OS44ICAgQzMzLjgsNjguNywzMi44LDY3LjcsMzEuNiw2Ny43eiBNMjcuMiw4NEgxNi45di05LjhoMTAuM1Y4NHoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNNzUuNSwxOS41bDEuOS00YzEuMy0yLjgtMC44LTYtMy45LTUuN2wtMjYuOCwyLjFjLTIuOSwwLjItNC41LDMuNS0yLjksNmwxNC42LDIxLjNjMiwyLjksNi40LDIuNiw3LjktMC42ICAgbDEuOS0zLjljMC41LTEsMS44LTEuMywyLjYtMC42YzYuMiw1LjIsMTAuMSwxMi45LDEwLjEsMjEuNmMwLDExLjgtNy4zLDIxLjktMTcuNSwyNi4xYy0yLjEsMC45LTMuNiwyLjgtMy43LDUgICBjLTAuMiw0LjEsMy45LDcuMSw3LjcsNS41YzE0LjUtNS44LDI0LjgtMjAuMSwyNC44LTM2LjdjMC0xMi44LTYuMS0yNC4xLTE1LjUtMzEuNEM3NS4yLDIzLjEsNzQuNywyMS4yLDc1LjUsMTkuNXoiPjwvcGF0aD48L2c+PC9zdmc+"
                                :style="{
                                  filter: `invert(0.5) sepia(${
                                    !choice.text ? 0 : 1
                                  }) saturate(5) hue-rotate(175deg)`,
                                }"
                              />
                            </v-avatar>
                          </v-btn>
                        </template>
                        <span>ย้าย</span>
                      </v-tooltip>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-item
                          v-for="(item, im) in condition.selected"
                          :key="im"
                          @click="MoveChoice(i, c, im)"
                        >
                          <v-list-item-title
                            >{{ qrbtn.length + (im + 1) }}.
                            {{ item.text }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                  <v-btn
                    color="#DE4F3B"
                    icon
                    v-show="
                      LastQuestion.type === 'quickReply'
                        ? true
                        : Object.keys(condition.selected).length > 1
                    "
                    @click="$delete(condition.selected, c), CheckMultiSelect(i)"
                    ><v-icon>mdi-trash-can-outline </v-icon></v-btn
                  >
                </v-col></v-row
              >
              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  color="#0278ae"
                  outlined
                  small
                  icon
                  dark
                  fab
                  @click="AddChoice(i)"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex justify-center">
                <v-row no-gutters>
                  <v-col cols="5" class="pt-2">เลือกได้น้อยที่สุด</v-col>
                  <v-col cols="7">
                    <v-text-field
                      v-model="condition.min_selected"
                      type="number"
                      solo
                      dense
                      full-width
                      label="เลือกได้น้อยที่สุด"
                      min="1"
                      class="mx-3"
                      :rules="[
                        $store.getters.NumberRangeRule({
                          amount: +condition.min_selected,
                          min: 1,
                          max: +condition.max_selected,
                        }),
                      ]"
                    >
                    </v-text-field
                  ></v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex justify-center">
                <v-row no-gutters>
                  <v-col cols="5" class="pt-2">เลือกได้มากที่สุด</v-col>
                  <v-col cols="7">
                    <v-text-field
                      v-model="condition.max_selected"
                      type="number"
                      solo
                      dense
                      label="เลือกได้มากที่สุด"
                      min="1"
                      class="mx-3"
                      :rules="[
                        $store.getters.NumberRangeRule({
                          amount: +condition.max_selected,
                          min: +condition.min_selected,
                          max: qrbtn.length + condition.selected.length,
                        }),
                      ]"
                    >
                    </v-text-field
                  ></v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center"
                v-if="!condition.hascompute"
              >
                <v-row no-gutters>
                  <v-col cols="2" class="pt-2">คำถามต่อไป</v-col>
                  <v-col cols="10">
                    <v-autocomplete
                      v-model="condition.defaultCondition.nextQuestionID"
                      :items="Jump"
                      label="เลือกคำถาม"
                      solo
                      dense
                      color="#0D8EEE"
                      item-text="questionLabel"
                      item-value="questionID"
                      :rules="[
                        $store.getters.TextRule(
                          condition.defaultCondition.nextQuestionID
                        ),
                      ]"
                      :menu-props="{
                        closeOnClick: true,
                        closeOnContentClick: true,
                        maxHeight: 200,
                      }"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item
                          @click="
                            condition.defaultCondition.nextQuestionID =
                              item.questionID
                          "
                        >
                          <v-list-item-title>
                            <v-row no-gutters align="center">
                              <span class="d-flex align-center">
                                {{ item.questionLabel }}
                              </span>
                            </v-row>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-radio-group
                  v-model="condition.hascompute"
                  row
                  label="คำนวณคะแนน"
                >
                  <v-radio label="มี" color="info" :value="true"></v-radio>
                  <v-radio label="ไม่มี" color="info" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div v-if="condition.hascompute">
          <div>
            <ComputeScore
              :computeCondition="condition.computeCondition"
              :Jump="Jump"
              :NextQuestion="NextQuestion"
            />
          </div>
        </div>
      </v-container>
    </v-alert>
  </div>
</template>

<script>
import ComputeScore from "./ComputeScore";
import _ from "lodash";
export default {
  props: ["rawmultiselect", "Jump", "NextQuestion", "LastQuestion"],
  components: { ComputeScore },
  computed: {
    operationlist() {
      return this.$store.state.operation;
    },
  },
  data() {
    return {
      qrbtn: [],
      multiselect: [
        {
          conditiontext: null,
          conditiontype: "multiselect",
          selected: [
            {
              text: "",
              value: 0,
              description: false,
              errorLabel: false,
              errorLabelMsg: "",
            },
          ],
          min_selected: 1,
          max_selected: 1,
          hascompute: false,
          defaultCondition: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
          computeCondition: {
            match: [
              {
                nextQuestionID: this.NextQuestion.questionID,
                operation: "",
                value: 0,
                value_from: 0,
                value_to: 0,
                score: 0,
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
            notmatch: {
              nextQuestionID: this.NextQuestion.questionID,
              score: 0,
            },
          },
        },
      ],
    };
  },
  created() {
    this.multiselect = this.rawmultiselect;
    if (this.LastQuestion.type === "quickReply") {
      this.multiselect.map((choice, i) => {
        this.AddAllButton(i);
      });
    }
  },
  watch: {
    LastQuestion: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (newValue.type === "quickReply") {
            this.multiselect.map((choice, i) => {
              this.AddAllButton(i);
            });
          } else {
            this.qrbtn = [];
            this.multiselect.map((choice, i) => {
              if (choice.selected.length === 0) {
                choice.selected.push({
                  text: "",
                  value: 0,
                  description: false,
                  errorLabel: false,
                  errorLabelMsg: "",
                });
              }
              this.CheckMultiSelect(i);
            });
          }
        }
      },
    },
    qrbtn: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          if (newValue && oldValue) {
            let dataforcombine = [];
            let tempmultiselect = JSON.parse(JSON.stringify(this.multiselect));
            let tempqrbtn = JSON.parse(JSON.stringify(this.qrbtn));
            tempmultiselect.map((choice) => {
              choice.selected = [...tempqrbtn, ...choice.selected];
              dataforcombine.push(choice);
            });
            this.$emit("multiselectchange", dataforcombine);
          }
        }
      },
    },
    multiselect: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && oldValue) {
          let dataforcombine = [];
          let tempmultiselect = JSON.parse(JSON.stringify(this.multiselect));
          let tempqrbtn = JSON.parse(JSON.stringify(this.qrbtn));
          tempmultiselect.map((choice) => {
            choice.selected = [...tempqrbtn, ...choice.selected];
            dataforcombine.push(choice);
          });
          this.$emit("multiselectchange", dataforcombine);
        }
      },
    },
  },
  methods: {
    RestoreCond(tempmulti, lastqType) {
      this.$nextTick(() => {
        this.qrbtn = [];
        this.multiselect = tempmulti;
        if (lastqType === "quickReply") {
          this.multiselect.map((choice, i) => {
            this.AddAllButton(i);
          });
        }
      });
    },
    AddChoice(i) {
      this.multiselect[i].selected.push({
        text: "",
        value: 0,
        description: false,
        errorLabel: false,
        errorLabelMsg: "",
      });
    },
    AddAllButton(i) {
      if (this.LastQuestion.type === "quickReply") {
        if (this.multiselect[i].selected.length === 1) {
          if (!this.multiselect[i].selected[0].text) {
            this.multiselect[i].selected.pop();
          }
        }
        let tempdata = JSON.parse(JSON.stringify(this.qrbtn));
        let tempqr = [];
        this.LastQuestion.buttons.map((qr) => {
          if (qr.type === "text") {
            let existButton = tempdata.find(
              (multiselect) => multiselect.text === qr.text
            );
            if (!existButton) {
              let samecustom = this.multiselect[i].selected.find(
                (multiselect) => multiselect.text === qr.text
              );
              if (samecustom) {
                tempqr.push(samecustom);
                this.multiselect[i].selected.splice(
                  this.multiselect[i].selected.indexOf(samecustom),
                  1
                );
              } else {
                tempqr.push({
                  text: qr.text,
                  value: 0,
                  description: false,
                  errorLabel: false,
                  errorLabelMsg: "",
                });
              }
            } else {
              tempqr.push(existButton);
            }
          }
        });
        this.qrbtn = tempqr;
        this.CheckMultiSelect(i);
      }
    },
    MoveChoice(i, index, moveindex) {
      let old_index = index;
      let new_index = moveindex;
      if (new_index >= this.multiselect[i].selected.length) {
        var k = new_index - this.multiselect[i].selected.length + 1;
        while (k--) {
          this.multiselect[i].selected.push(undefined);
        }
      }
      this.multiselect[i].selected.splice(
        new_index,
        0,
        this.multiselect[i].selected.splice(old_index, 1)[0]
      );
    },
    CheckMultiSelect(index) {
      let combine = [...this.qrbtn, ...this.multiselect[index].selected];
      combine.map((item) => {
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(combine, "text");
      let dup = _.filter(combine, (x) => counts[x.text] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.text) {
            item.errorLabel = true;
            item.errorLabelMsg =
              "ชื่อ multi select นี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    },
    CheckMultiSelectType: _.debounce(function (index) {
      let combine = [...this.qrbtn, ...this.multiselect[index].selected];
      combine.map((item) => {
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(combine, "text");
      let dup = _.filter(combine, (x) => counts[x.text] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.text) {
            item.errorLabel = true;
            item.errorLabelMsg =
              "ชื่อ multi select นี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    }, 0),
  },
};
</script>

<style lang="scss" scoped></style>
